import { convertToSnakeCase } from "~/features/configurator/Shaft/shaftGaHelper";
import type { SummaryData } from "~/features/configurator/Shaft/SummaryDataProvider";
import { removeMultipleTags } from "~/common/utils/domUtils";

export function prepareSummaryDataName(summaryData: Pick<SummaryData, "name">): string;
export function prepareSummaryDataName(summaryData: string): string;
export function prepareSummaryDataName(summaryData: string | Pick<SummaryData, "name">) {
  let name: string;
  if (typeof summaryData === "string") {
    name = summaryData;
  } else {
    name = summaryData.name?.toString() ?? "";
  }
  name = removeMultipleTags(name, "p", "strong", "sub")!;
  // Remove "(mm)" from the name, even if there are spaces in between
  name = name.replace(/\(\s*mm\s*\)/g, "").trim();
  return convertToSnakeCase(name);
}

export function prepareSummaryDataValue(summaryData: Pick<SummaryData, "value">) {
  let value = summaryData.value?.toString() ?? "";
  value = removeMultipleTags(value, "p", "strong", "sub")!;
  // Collapse whitespace into a single space
  value = value.replace(/\s+/g, " ").trim();
  return value;
}

export function prepareSummaryDataValues(values: SummaryData[]) {
  const result = {} as Record<string, string>;
  values.forEach((value) => {
    result[prepareSummaryDataName(value)] = prepareSummaryDataValue(value);
  });
  return result;
}
